var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Preview from "@/components/widgets/list/preview";
import { useMemo, useState } from "react";
import { FACELIFTDEF } from "@/components/fields/facelift/const";
import DisplayField from "@/components/fields/displayField";
import { FieldViewType } from "@/components/fields/viewType";
export default function NameFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, moduleName = _a.moduleName;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""];
    }, [fieldName, record]);
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var handleClick = function (value) {
        setClicked(value);
    };
    return (_jsxs("div", __assign({ className: "flex flex-row justify-between relative " }, { children: [_jsx("span", __assign({ className: "items-center mx-2 my-1" }, { children: _jsx(DisplayField, { fieldName: "facelift", viewType: FieldViewType.LIST, fieldMetadata: FACELIFTDEF, record: record, moduleName: moduleName, hideLabel: true }) })), _jsx("span", __assign({ className: "flex items-center w-[2px] flex-1 overflow-hidden" }, { children: _jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(moduleName, "/DetailView/").concat(record.id), rel: "noopener noreferrer", className: "text-blue-700 hover:text-blue-400 truncate" }, { children: value && value })) })), _jsx("div", __assign({ className: "pr-2" }, { children: _jsx(Preview, { record: record, module: moduleName || "", handleClick: handleClick }) }))] })));
}
